/* Drakis — theme.js */
(function () {
  'use strict';

  /* Menú móvil */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* Filtros y orden en colecciones: enviar al cambiar */
  document.querySelectorAll('[data-facets-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      form.submit();
    });
  });

  /* Selector de cantidad */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    value = plus ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Página de producto: galería y variantes */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }
    var variants = data.variants || [];

    var slides = root.querySelectorAll('[data-media-id]');
    var thumbs = root.querySelectorAll('[data-thumb]');

    function showMedia(id) {
      if (!id) return;
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === String(id));
      });
      thumbs.forEach(function (thumb) {
        var on = thumb.getAttribute('data-thumb') === String(id);
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.getAttribute('data-thumb'));
      });
    });

    var picker = root.querySelector('[data-variant-picker]');
    if (!picker) return;

    var idInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var priceWrap = root.querySelector('.price');

    function selectedOptions() {
      var values = [];
      picker.querySelectorAll('fieldset').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (variants[i].options[j] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function update() {
      var variant = findVariant(selectedOptions());
      if (idInput) {
        idInput.disabled = !(variant && variant.available);
        if (variant) idInput.value = variant.id;
      }
      if (addButton) addButton.disabled = !(variant && variant.available);
      if (addLabel) {
        addLabel.textContent = !variant
          ? 'No disponible'
          : variant.available
          ? 'Agregar al carrito'
          : 'Agotado';
      }
      if (variant) {
        if (priceEl) priceEl.textContent = variant.price;
        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.hidden = !variant.onSale;
        }
        if (priceWrap) priceWrap.classList.toggle('price--sale', !!variant.onSale);
        if (variant.mediaId) showMedia(variant.mediaId);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    picker.addEventListener('change', update);
  }

  document.querySelectorAll('[data-product]').forEach(initProduct);

  /* Portada: frasco que se inclina y cápsulas flotantes */
  function initHeroStage(stage) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var area = stage.closest('[data-hero]') || stage;
    var bottle = stage.querySelector('[data-bottle]');
    var spin = stage.querySelector('[data-bottle-spin]');
    var capsules = stage.querySelectorAll('[data-capsule]');
    var counter = stage.querySelector('[data-capsule-counter]');
    var caught = 0;
    var frame = null;
    var nx = 0;
    var ny = 0;

    function clamp(v) {
      return Math.max(-1, Math.min(1, v));
    }

    function paint() {
      frame = null;
      if (bottle) {
        bottle.style.setProperty('--ry', (nx * 12).toFixed(2) + 'deg');
        bottle.style.setProperty('--rx', (-ny * 9).toFixed(2) + 'deg');
      }
      capsules.forEach(function (c) {
        var depth = parseFloat(c.getAttribute('data-depth')) || 0;
        c.style.setProperty('--px', (nx * depth * 36).toFixed(1) + 'px');
        c.style.setProperty('--py', (ny * depth * 36).toFixed(1) + 'px');
      });
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(paint);
    }

    if (!reduce) {
      area.addEventListener('pointermove', function (e) {
        var r = area.getBoundingClientRect();
        nx = clamp(((e.clientX - r.left) / r.width - 0.5) * 2);
        ny = clamp(((e.clientY - r.top) / r.height - 0.5) * 2);
        schedule();
      });
      area.addEventListener('pointerleave', function () {
        nx = 0;
        ny = 0;
        schedule();
      });
    }

    capsules.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.classList.contains('is-popped')) return;
        c.classList.add('is-popped');
        caught += 1;
        if (counter) {
          var text = caught === 1 ? '¡Atrapaste 1 cápsula!' : '¡Atrapaste ' + caught + ' cápsulas!';
          if (caught >= 5) text += ' ¡Buena puntería!';
          counter.textContent = text;
          counter.hidden = false;
          counter.style.animation = 'none';
          void counter.offsetWidth;
          counter.style.animation = '';
        }
        window.setTimeout(function () {
          c.classList.remove('is-popped');
        }, 1800);
      });
    });

    if (bottle && spin && !reduce) {
      bottle.addEventListener('click', function () {
        spin.classList.remove('is-spinning');
        void spin.offsetWidth;
        spin.classList.add('is-spinning');
      });
    }
  }

  document.querySelectorAll('[data-hero-stage]').forEach(initHeroStage);
})();
